import { callApi } from '@/api/apibase'

export const getGreenCourse = function (locationId) {
  const requestData = {
    locationId: locationId
  }
  return callApi('POST', '/api/external/greencourse/get', requestData)
}
